const updateCartAndOpenCartDrawer = async () => {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      sections: "cart_data,mini_cart",
      sections_url: window.location.pathname,
    }),
  });

  const data = await response.json();

  T4SThemeSP.Cart.renderContents(data.sections);

  const cartIcon = document.querySelector(".t4s-site-nav__cart > a");

  if (cartIcon) {
    cartIcon.click();
  }
};

const moveElementAfter = (target, after) => {
  const targetEl = document.querySelector(target);
  const afterEl = document.querySelector(after);
  if (targetEl && afterEl) {
    afterEl.after(targetEl);
    return true;
  }
  return false;
};

document.addEventListener("teeinblue-event-after-cart-added", () => {
  updateCartAndOpenCartDrawer();
});

document.addEventListener("teeinblue-event-component-injected", () => {
  //move cross-sell below tee price
  moveElementAfter(".t4s-complimentary", ".tee-block.tee-product-price");

  // move description to media column for balancing
  if (window.screen.width >= 768) {
    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelector("#tee-gallery")) {
        if (!moveElementAfter(".tee-description", ".tee-thumbnails")) {
          moveElementAfter(".tee-description", ".tee-slider");
        }
        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});
